import React from "react";
import {
  AppstoreOutlined,
  FontSizeOutlined,
  PictureOutlined,
  BarcodeOutlined,
  QrcodeOutlined,
  TableOutlined,
  MinusOutlined,
  ColumnHeightOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
import { Button, Space } from "antd";
import { Locale } from "../../../../utils";
import { flattenRowChildren } from "../catalog";
import "./ComponentOutline.scss";

const i18n = Locale.getInstance();

function iconFor(type) {
  switch (type) {
    case "image":
      return <PictureOutlined />;
    case "barcode":
      return <BarcodeOutlined />;
    case "qrcode":
      return <QrcodeOutlined />;
    case "product-table":
      return <TableOutlined />;
    case "divider":
      return <MinusOutlined />;
    case "spacer":
      return <ColumnHeightOutlined />;
    case "stack":
      return <ClusterOutlined />;
    default:
      return <FontSizeOutlined />;
  }
}

function OutlineItems({ children, selectedId, onSelect, depth = 0 }) {
  return (children || []).map((comp) => {
    if (comp.type === "stack") {
      return (
        <div key={comp.id} className="component-outline__stack">
          <div
            className="component-outline__item component-outline__item--stack"
            style={{ paddingLeft: 8 + depth * 12 }}
          >
            {iconFor("stack")}
            <span>
              {i18n.t("order.printTemplate.sideStack")} (
              {(comp.children || []).length}
              {i18n.t("order.printTemplate.itemsUnit")})
            </span>
          </div>
          <OutlineItems
            children={comp.children}
            selectedId={selectedId}
            onSelect={onSelect}
            depth={depth + 1}
          />
        </div>
      );
    }
    return (
      <button
        key={comp.id}
        type="button"
        className={`component-outline__item ${
          selectedId === comp.id ? "is-selected" : ""
        }`}
        style={{ paddingLeft: 8 + depth * 12 }}
        onClick={() => onSelect?.(comp.id)}
      >
        {iconFor(comp.type)}
        <span>{i18n.t(comp.label) || comp.type}</span>
      </button>
    );
  });
}

export default function ComponentOutline({
  rows = [],
  selectedId,
  onSelect,
  onMove,
  onCopy,
  onDelete,
}) {
  return (
    <div className="component-outline">
      <div className="component-outline__title">
        {i18n.t("order.printTemplate.outline")}
      </div>
      <div className="component-outline__tree">
        {rows.map((row) => (
          <div key={row.id} className="component-outline__row">
            <div className="component-outline__row-head">
              <AppstoreOutlined />
              <span>
                {i18n.t("order.printTemplate.rowContainer")} (
                {flattenRowChildren(row.children || []).length}
                {i18n.t("order.printTemplate.itemsUnit")})
              </span>
            </div>
            <div className="component-outline__children">
              <OutlineItems
                children={row.children}
                selectedId={selectedId}
                onSelect={onSelect}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="component-outline__footer">
        <Space size={4} wrap>
          <Button size="small" disabled={!selectedId} onClick={() => onMove?.(-1)}>
            {i18n.t("order.printTemplate.moveUp")}
          </Button>
          <Button size="small" disabled={!selectedId} onClick={() => onMove?.(1)}>
            {i18n.t("order.printTemplate.moveDown")}
          </Button>
          <Button size="small" disabled={!selectedId} onClick={() => onCopy?.()}>
            {i18n.t("order.printTemplate.copy")}
          </Button>
          <Button
            size="small"
            danger
            disabled={!selectedId}
            onClick={() => onDelete?.()}
          >
            {i18n.t("order.printTemplate.delete")}
          </Button>
        </Space>
      </div>
    </div>
  );
}
